import React from "react";
import StatusChip from "./StatusChip";
import { DISPUTE_STATUS } from "../../utils/enums";

interface Props {
  status: string;
}

const DisputeStatusChip: React.FC<Props> = ({ status }) => {
  switch (status) {
    case DISPUTE_STATUS.NEW:
      return (
        <StatusChip
          tone="primary"
          icon="bi-exclamation-circle-fill"
          label="Active"
        />
      );
    case DISPUTE_STATUS.INPROGRESS:
      return (
        <StatusChip
          tone="warning"
          icon="bi-arrow-repeat"
          label="In-Progress"
        />
      );
    case DISPUTE_STATUS.RESOLVED:
      return (
        <StatusChip
          tone="success"
          icon="bi-check-circle-fill"
          label="Resolved"
        />
      );
    default:
      return null;
  }
};

export default DisputeStatusChip;
